import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class Api {
  private readonly http = inject(HttpClient);
  private readonly api = environment.apiUrl;

  test() {
    return this.http.get('https://api.v1.demcfpd.dev.agco-opsmgmt.com/metaparticles');
  }

  getMaterials() {
    return this.http.get<Material[]>(`${this.api}/materials`);
  }

  createParticle(materialId: string) {
    const path = `${this.api}/materials/${materialId}/particles`;
    return this.http.post<Particle[]>(path, {
      shape: {
        type: 'multi_sphere',
        layout_table: [
          {
            name: 'string',
            position: { x: 0, y: 0, z: 0 },
            physical_radius: 1,
            contact_radius: 1,
          },
        ],
      },
      size_distribution: {
        distribution_type: 'fixed',
        ratio: 1,
        scale_by: 'radius',
      },
    });
  }

  getParticles(materialId: string, version: string) {
    return this.http.get<Particle[]>(
      `${this.api}/materials/${materialId}${encodeURIComponent('#' + version)}/particles`,
    );
  }

  getMetaParticles() {
    return this.http.get<MetaParticle[]>(`${this.api}/metaparticles`);
  }
}
